import {
    SET_VIDEO_VIEWWIDTH,
    SET_SUBTITLES_LEFT
} from '../actions/types';

const initialState = {
    viewWidth:448,
    viewHeight:341,

    subtitles_Left:500,
};

export default function(state = initialState, action) {
    switch (action.type) {

        case SET_VIDEO_VIEWWIDTH:
            return {
                ...state,
                viewWidth: action.payload.viewWidth,
                viewHeight: action.payload.viewHeight
            };

        case SET_SUBTITLES_LEFT:
            return {
                ...state,
                subtitles_Left: action.payload
            };


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ViewReducer.js